export default __webpack_public_path__ + "static/media/login_bg.e16ed69c.svg";